import Fox, { FoxState } from '../../../Prototype/World/Fox';
import TransformComponent from '../../../Component/Transform';
import Game from '../../../Game';
import FoxComponent from '../../../Component/World/Fox';
import { Random } from '../../../Utility/Random';
import TextComponent from '../../../Component/Render/Text';
import { delay } from '../../../Utility/Task/TaskQueue';
import {
    PlayAnimation,
    GetAnimationClip,
} from '../../Animation/AnimationHelper';
import SpriteComponent from '../../../Component/Render/Sprite';
import Interactable from '../../../Component/Interactable';
import DateHelper from '../../../Utility/DateHelper';

const TWELVE_HOURS = DateHelper.hoursToMilliseconds(12);

export default class FoxHandler {
    private fox: Fox;
    private timerInterval: any;

    constructor(fox: Fox) {
        this.fox = fox;
        this.fox.getComponent(Interactable).enabled = false;
    }

    public setFoxPosition(foxComponentData: any): void {
        const world: number = Game.player.getActiveWorldNumber();
        const level: number =
            (Game.player.getCurrentWorldLevel(world) - 1) % 60;
        const index: number = level < 25 ? 0 : level < 45 ? 1 : 2;

        if (!foxComponentData) {
            console.error(
                `Fox position was not defined for this world ${world}.`
            );
            if (index === 0) {
                this.fox
                    .getComponent(TransformComponent)
                    .position.set(960, 3260);
            } else if (index === 1) {
                this.fox
                    .getComponent(TransformComponent)
                    .position.set(960, 2250);
            } else {
                this.fox
                    .getComponent(TransformComponent)
                    .position.set(960, 1060);
            }
        } else {
            this.fox
                .getComponent(TransformComponent)
                .position.set(
                    foxComponentData.positions[index].x,
                    foxComponentData.positions[index].y
                );
        }
    }

    public startFoxTimerInterval(): void {
        if (Game.state.getState().playerState.foxTimer === null) return;
        if (typeof this.timerInterval === 'function') return;

        this.onFoxTimer();
        this.timerInterval = Game.ticker.setInterval(
            this.onFoxTimer.bind(this),
            DateHelper.minutesToMilliseconds(1) // every minute
        );
    }

    public stopFoxTimerInterval(): void {
        Game.ticker.clearInterval(this.timerInterval);
        this.timerInterval = null;
    }

    private onFoxTimer(): void {
        const currentFoxTimerDate = Game.state.getState().playerState.foxTimer;
        if (currentFoxTimerDate === null) {
            Game.ticker.clearInterval(this.timerInterval);
            this.timerInterval = null;
            return;
        }

        const now = DateHelper.now();
        const timeDiff =
            now.getTime() -
            DateHelper.getDateFromValue(currentFoxTimerDate).getTime();

        if (timeDiff >= TWELVE_HOURS) {
            this.setFoxState(FoxState.FOUND);
        }
    }

    public setFoxState(state: FoxState): void {
        const foxComponent = this.fox.getComponent(FoxComponent);
        if (!foxComponent) {
            return;
        }

        switch (state) {
            case FoxState.SEARCHING:
                foxComponent.status = FoxState.SEARCHING;
                this.fox.children[1].getComponent(SpriteComponent).texture =
                    'fox';
                this.fox.getComponent(Interactable).enabled = false;
                break;
            case FoxState.FOUND:
                foxComponent.status = FoxState.FOUND;
                this.fox.children[1].getComponent(SpriteComponent).texture =
                    'fox_happy';
                this.fox.getComponent(Interactable).enabled = true;
                break;
        }
    }

    public *speak(): IterableIterator<number> {
        // Loop forever (or until coroutine is destroyed).
        while (true) {
            // Wait 3-7 seconds.
            yield* delay(Random.int(3000, 7000));

            // Change the fox message.
            this.setRandomMessage();

            // Popup message.
            yield* PlayAnimation(
                GetAnimationClip('SpeechBubblePopUp', this.fox.children[2])
            );
        }
    }

    private setRandomMessage(): void {
        // FoxText [1...4] When quest is not complete. (ignored)
        // FoxText [5...8] When quest is complete (but no reward found).
        // FoxText [9...12] When reward is ready.
        const foxComponent: FoxComponent = this.fox.getComponent(FoxComponent);

        let id: number;
        if (foxComponent.state === FoxState.SEARCHING) {
            id = Random.int(5, 8);
        } else if (foxComponent.state === FoxState.FOUND) {
            id = Random.int(9, 12);
        }

        this.fox.children[2].children[1].getComponent(
            TextComponent
        ).text = Game.locale.getText(`FoxText${id}`);
    }
}
